import { CalendarDays, CalendarRange, Clock3, Rows3 } from "lucide-react";
import type { SalesPeriod } from "../types";

type CardPeriod = "day" | "yesterday" | "week" | "all";

interface Props {
  counts: Record<CardPeriod, number> | null;
  activePeriod: SalesPeriod;
  onSelectPeriod: (period: CardPeriod) => void;
}

const cards = [
  { period: "day", label: "Объявлений сегодня", icon: CalendarDays, tone: "green" },
  { period: "yesterday", label: "За вчера", icon: CalendarRange, tone: "neutral" },
  { period: "week", label: "За 7 дней", icon: Clock3, tone: "lime" },
  { period: "all", label: "За всё время", icon: Rows3, tone: "purple" }
] as const;

export function SalesSummary({ counts, activePeriod, onSelectPeriod }: Props) {
  return <section className="summary-grid" aria-label="Объявления по периодам">
    {cards.map(({ period, label, icon: Icon, tone }) => <button
      className={`summary-card tone-${tone}${activePeriod === period ? " is-active" : ""}`}
      key={period}
      type="button"
      aria-pressed={activePeriod === period}
      onClick={() => onSelectPeriod(period)}
      disabled={!counts}
    >
      <div><span>{label}</span><Icon size={18} /></div>
      <strong>{counts ? counts[period].toLocaleString("ru-RU") : "—"}</strong>
      <small>С учётом фильтров · открыть ↓</small>
    </button>)}
  </section>;
}
